<section>
  <ng-container *ngIf="loadingBanners; else bannerCarousel">
    <div class="container">
      <p-skeleton width="100%" height="70vh"></p-skeleton>
    </div>
  </ng-container>
  <ng-template #bannerCarousel>
    <p-carousel
      [value]="filteredBanners"
      [circular]="true"
      [showIndicators]="true"
      [showNavigators]="false"
      class="banner-carousel relative"
      [autoplayInterval]="5000"
    >
      <ng-template let-banner pTemplate="item">
        <div class="hero-banner relative" (click)="handleRedirection(banner.attributes.banner_url)">
          <img class="hero-img" [src]="banner.attributes.banner_image" alt="" srcset="">
        </div>
      </ng-template>
    </p-carousel>
  </ng-template>
</section>
